import { CardLayout } from '../../../shared/components';
import { getHouseholdsText } from '../utils';

export type WardMarkerCardProps = {
  wardName: string;
  numberOfHouseholds: number;
  setClickedMarker: (marker: null) => void;
}
export default function WardMarkerCard({ wardName, numberOfHouseholds, setClickedMarker }: Readonly<WardMarkerCardProps>) {
  const householdsText = getHouseholdsText(numberOfHouseholds);
  return (
    <CardLayout title={wardName} onClose={() => setClickedMarker(null)}>
      <p className="text-body-regular">{householdsText}</p>
    </CardLayout>
  );
}
